import { lazy } from 'react';

const RecoveringPassword = lazy(() =>
  import(
    /* webpackChunkName: "RecoveringPassword" */ '@common2/Authorization/RecoveringPassword/RecoveringPassword'
  )
);

export default RecoveringPassword;
